$(window).on("scroll",function(){var scrollTop=$(window).scrollTop(),scrollThreshold=$(window).width()<=768?0:469;scrollTop>=scrollThreshold?$(".product-sticky-bar.opacitychange").css("display","block"):$(".product-sticky-bar.opacitychange").css("display","none")}),$(document).ready(function(){$(".slider").slick({dots:!1,infinite:!0,slidesToShow:1,slidesToScroll:1,autoplay:!0,autoplaySpeed:3e3,arrows:!1})}),$(document).ready(function(){$(".four-card-slider .slider").slick({dots:!1,infinite:!0,slidesToShow:4,slidesToScroll:1,responsive:[{breakpoint:1024,settings:{slidesToShow:3,slidesToScroll:1}},{breakpoint:768,settings:{slidesToShow:2,slidesToScroll:1}},{breakpoint:480,settings:{slidesToShow:1,slidesToScroll:1}}]})});
//# sourceMappingURL=/s/files/1/0233/6459/9885/t/80/assets/custom.js.map?v=1725969850

// for hide header and footer on landingpage

// document.addEventListener("DOMContentLoaded", function() {
//     // Get the current page pathname
//     const currentPagePath = window.location.pathname;

//     // Path of the page where you want to hide the header and footer
//     const targetPagePath = "/pages/amazondeals";

//     // Check if the current page matches the target page
//     if (currentPagePath === targetPagePath) {
//         // Hide the header
//         const header = document.querySelector('header'); // Adjust the selector if necessary
//         if (header) {
//             header.style.display = 'none';
//         }

//         // Hide the footer
//         const footer = document.querySelector('footer'); // Adjust the selector if necessary
//         if (footer) {
//             footer.style.display = 'none';
//         }
//     }
// });




